<script setup lang="ts">
import { computed } from 'vue';
import AttachmentCard, { type IAttachmentCardItem } from './AttachmentCard.vue';
const props = withDefaults(
  defineProps<{
    items: IAttachmentCardItem[];
    removable?: boolean;
    disabled?: boolean;
    previewOnly?: boolean;
    elevated?: boolean;
    inline?: boolean;
    /** Mobile: one horizontally scrollable row instead of wrapping. */
    scrollable?: boolean;
  }>(),
  { previewOnly: false, inline: false, scrollable: false },
);
const emit = defineEmits<{ remove: [item: IAttachmentCardItem] }>();
const gridClass = computed(() => {
  if (props.inline) return 'contents';
  return [
    'flex w-full gap-md md:grid md:grid-cols-3',
    props.scrollable
      ? 'overflow-x-auto overscroll-x-contain [scrollbar-width:none] [&::-webkit-scrollbar]:hidden md:overflow-visible'
      : 'flex-wrap',
  ];
});
</script>

<template>
  <div :class="gridClass">
    <AttachmentCard
      v-for="item in items"
      :key="`${item.type}-${item.id}-${item.imageSource}`"
      :item="item"
      :removable="removable"
      :disabled="disabled"
      :preview-only="previewOnly"
      :elevated="elevated"
      @remove="emit('remove', item)"
    />
    <slot />
  </div>
</template>
